// CountdownRing.tsx — the near-universal visual for this category (every competitor researched —
// Forest, Focus Keeper, Be Focused — centers a circular progress indicator, not a plain digit clock).
// Pure CSS animation, no JS ticking: matches this app's existing "scheduled completion, not a 1s
// poll" architecture (see Timer's own comment) — the ring drains via a single CSS animation whose
// duration is set once at session start, same principle as the single setTimeout.
export function CountdownRing({
  running, durationSec, size = 220, stroke = 6,
}: {
  running: boolean;
  durationSec: number;
  size?: number;
  stroke?: number;
}) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ position: "absolute", inset: 0, transform: "rotate(-90deg)" }} aria-hidden>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--border)" strokeWidth={stroke} />
      {running && (
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--accent)" strokeWidth={stroke}
          strokeDasharray={c} strokeLinecap="round"
          style={{
            "--ring-c": c,
            animation: `ring-drain ${durationSec}s linear forwards`,
          } as React.CSSProperties}
        />
      )}
    </svg>
  );
}
